import { GoogleMap } from "@react-google-maps/api";
import React from "react";
import { useGoogleMaps } from "../../../context/GoogleMapsProvider";

const containerStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "12px 12px 12px 12px",
};

const center = {
  lat: -3.745,
  lng: -38.523,
};

function MapView() {
  const { isLoaded } = useGoogleMaps();

  const [mapView, setMapView] = React.useState(null);

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    setMapView(mapView);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMapView(null);
  }, []);

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={5}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      <></>
    </GoogleMap>
  ) : (
    <></>
  );
}

export default MapView;
